export default __webpack_public_path__ + "static/media/icon--calendar.afeb9dd3.svg";